// The highlight menu portals into a disposable host so React owns a stable
// child list. TipTap/browser translation can move portal children around;
// keeping React isolated on a short-lived host avoids removeChild NotFoundError.

export function createHighlightMenuPortalHost(portalNode) {
  if (!portalNode?.ownerDocument) {
    return null;
  }

  const host = portalNode.ownerDocument.createElement("div");
  // Browser translation and editor teardown can move portal children before
  // React's commit cleanup runs. Keep the tolerance scoped to this disposable host.
  const removeChild = host.removeChild.bind(host);
  host.removeChild = (child) => {
    if (child?.parentNode !== host) {
      return child;
    }

    return removeChild(child);
  };

  host.setAttribute("data-tiptap-highlight-menu-portal-host", "true");
  host.setAttribute("translate", "no");
  host.className = "notranslate";
  // Mark the host non-editable/non-translatable so selection, ProseMirror
  // input, and browser translation layers ignore React-owned portal nodes.
  host.contentEditable = "false";
  portalNode.appendChild(host);
  return host;
}

export function removeHighlightMenuPortalHost(host) {
  // Teardown is intentionally tolerant: editor cleanup can detach the
  // host before React unmounts the portal, and the cleanup path must stay quiet.
  if (host?.parentNode) {
    host.parentNode.removeChild(host);
  }
}

export function isQueryableDocumentRef(documentRef) {
  return Boolean(documentRef && typeof documentRef.querySelector === "function");
}
